export default __webpack_public_path__ + "static/media/ai_face_recognitionActive.5d5c23e1.svg";